import { useState } from 'react';

import { FormattedIntervalUnit, RunOn } from '../types';

const useScheduleState = ({
  initialIntervalUnit,
  initialRunOn,
  initialUnitCycle,
  initialStartDate,
  initialEndDate,
}: {
  initialIntervalUnit: FormattedIntervalUnit;
  initialRunOn: RunOn[];
  initialUnitCycle: string;
  initialStartDate?: Date | null;
  initialEndDate?: Date | null;
}) => {
  const [selectedUnit, setSelectedUnit] =
    useState<FormattedIntervalUnit>(initialIntervalUnit);

  const [runOn, setRunOn] = useState(initialRunOn);

  const [unitCycle, setUnitCycle] = useState(parseInt(initialUnitCycle));

  const [runAtTime, setRunAtTime] = useState<{
    label: string;
    value: string;
  } | null>(null);

  const [dates, setDates] = useState([initialStartDate, initialEndDate]);

  return {
    selectedUnit,
    setSelectedUnit,
    runOn,
    setRunOn,
    unitCycle,
    setUnitCycle,
    runAtTime,
    setRunAtTime,
    dates,
    setDates,
  };
};

export default useScheduleState;
